import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-passwords.delete', {
        url: '/delete',
        params: {accounts: []},
		//component: 'companySharingCenterSharedAuthenticatorsDelete',
		views: {
            '@company.sharing-center': 'companySharingCenterSharedPasswordsDelete'
        },
        resolve: {
            accounts,
			companyId
        },
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}

/** @ngInject */
function companyId($stateParams) {
    return $stateParams.companyId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/delete/delete-accounts.state.js